import { h, resolveComponent } from "vue";
import { createRouter, createWebHashHistory } from "vue-router";
import { isAuthenticated, getUserRole } from "@/utils/authUtils";

import DefaultLayout from "@/layouts/DefaultLayout";
const routes = [
  {
    path: "/admin",
    name: "Admin",
    component: DefaultLayout,

    redirect: "/admin/user",
    children: [
      {
        path: "/admin/user",
        name: "User Master",
        component: () => import("@/components/AdminPanel/UserMaster.vue"),
        meta: { roles: ["Admin"] },
      },
      {
        path: "/admin/brand",
        name: "Brand Master",
        component: () => import("@/components/AdminPanel/BrandMaster.vue"),
        meta: { roles: ["Admin"] },
      },
      {
        path: "/admin/net",
        name: "Net Weight Master",
        component: () => import("@/components/AdminPanel/NetWeightMaster.vue"),
        meta: { roles: ["Admin"] },
      },
      {
        path: "/admin/role",
        name: "Role Master",
        component: () => import("@/components/AdminPanel/RoleMaster.vue"),
        meta: { roles: ["Admin"] },
      },
      {
        path: "/admin/sku",
        name: "SKU Type Master",
        component: () => import("@/components/AdminPanel/SKUTypeMaster.vue"),
        meta: { roles: ["Admin"] },
      },

      // {
      //   path: "/admin/reports",
      //   name: "Retailer Reports",
      //   component: () => import("@/components/ReportPage.vue"),
      //   meta: { roles: ["Admin"] },
      // },
      // {
      //   path: "/admin/pkdreports",
      //   name: "PKD Reports",
      //   component: () => import("@/components/PKDReportPage.vue"),
      //   meta: { roles: ["Admin"] },
      // },

      // {
      //   path: "/admin/wholesaler-reports",
      //   name: "Wholesaler Reports",
      //   component: () => import("@/components/WholesalerReportPage.vue"),
      //   meta: { roles: ["Admin"] },
      // },
      // {
      //     path: "/admin/dailyreports",
      //     name: "Daily Pkd Reports",
      //     component: () => import("@/components/AdminPanel/DailyPkdReport.vue"),
      //     meta: { roles: ["Admin"] },
      //   },
      {
        path: "/admin/automailer",
        name: "Automailers",
        component: () => import("@/components/AdminPanel/AutoMailer.vue"),
        meta: { roles: ["Admin"] },
      },
      {
        path: "/automailer-log",
        name: "AutomailerLog",
        component: () => import("@/components/AutomailerLog.vue"),
      },
      {
        path: "/admin/settings",
        name: "Settings",
        component: () => import("@/components/AdminPanel/SettingsMaster.vue"),
        meta: { roles: ["Admin"] },
      },
      {
        path: "/admin/MarketVisibilityReport",
        name: "Market Visibility Reports",
        component: () => import("@/components/MarketVisibilityReport.vue"),
        meta: { roles: ["Admin"] },
      },
      {
        path: "/admin/MarketActivityReport",
        name: "Market Activity Reports",
        component: () => import("@/components/MarketActivityReport.vue"),
        meta: { roles: ["Admin"] },
      },
      {
        path: "/user/attendenceReport",
        name: "Attendence Report",
        component: () => import("@/components/AttendenceReport.vue"),
        meta: { roles: ["Admin"] },
      },
      {
        path: "/user/outletMaster",
        name: "Outlet Master",
        component: () => import("@/components/OutletMaster.vue"),
        meta: { roles: ["Admin"] },
      },
      {
        path: "/user/proximityReport",
        name: "Proximity Report",
        component: () => import("@/components/ProximityReport.vue"),
        meta: { roles: ["Admin"] },
      },


    ],
  },
  // Regular user routes
  {
    path: "/user",
    component: DefaultLayout,
    children: [
      {
        path: "/user/new-dashboard",
        name: "New Dashboard",
        component: () => import("@/components/NewDashboard.vue"),
        meta: { roles: ["Regularuser"] },
      },
      {
        path: "/user/web-form",
        name: "Retailer Tracking Form",
        component: () => import("@/components/WebForm.vue"),
        meta: { roles: ["Regularuser"] },
      },
      {
        path: "/user/wholesaler-web-form",
        name: "Wholesaler Tracking Form",
        component: () => import("@/components/WholesalerWebForm.vue"),
        meta: { roles: ["Regularuser"] },
      },
      {
        path: "/user/Pkd-web-form",
        name: "ADD PKDForms",
        component: () => import("@/components/PKDForms.vue"),
        meta: { roles: ["Regularuser"] },
      },
      {
        path: "/user/market-visit-form",
        name: "Add Market Visit Data",
        component: () => import("@/components/MarketVisitForm.vue"),
        meta: { roles: ["Regularuser"] },
      },
      {
        path: "/user/dashboard",
        name: "Filled Forms List",
        component: () => import("@/components/AdminPanel/DashBoard.vue"),
        meta: { roles: ["Regularuser"] },
      },
      {
        path: "/user/filled-form",
        name: "Filled Form Master",
        component: () => import("@/components/FilledForms.vue"),
        meta: { roles: ["Regularuser"] },
      },
      {
        path: "/user/edit-form/:formId",
        name: "EditForm",
        component: () => import("@/components/EditForm.vue"),
        meta: { roles: ["Regularuser"] },
      },
    ],
  },

  {
    path: "/",
    redirect: "/login",
    component: {
      render() {
        return h(resolveComponent("router-view"));
      },
    },
    children: [
      {
        path: "login",
        name: "Login",
        component: () => import("@/components/LoginPage.vue"),
      },
      {
        path: "/forgot-password",
        name: "Forgot Password",
        component: () => import("@/components/ForgotPassword.vue"),
      },
      {
        path: "/reset-password",
        name: "Reset Password",
        component: () => import("@/components/ResetPassword.vue"),
      },
      {
        path: "/unauthorized",
        name: "Unauthorized",
        component: () => import("@/components/UnauthorizedPage.vue"), // Unauthorized access page
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
});
router.beforeEach((to, from, next) => {
  // Check if the user is authenticated using our auth utilities
  if (isAuthenticated()) {
    // Check if the route requires role-based authorization
    if (to.meta.roles) {
      const userRole = getUserRole();
      if (userRole && to.meta.roles.includes(userRole)) {
        next(); // Allow navigation
      } else {
        // Redirect to unauthorized if user doesn't have required role
        next("/unauthorized");
      }
    } else {
      next(); // Continue navigation for routes without role restrictions
    }
  } else {
    // If not authenticated, only allow navigation to the login page and the
    // password-reset pages (a user who forgot their password is, by
    // definition, not authenticated yet).
    const publicPaths = ["/login", "/forgot-password", "/reset-password"];
    if (publicPaths.includes(to.path)) {
      next(); // Continue to the requested public page
    } else {
      next("/login"); // Redirect to login page for all other routes
    }
  }
});

export default router;
